<template lang="pug">
.page500
  .box
    img(:src="banner" alt="")
    h1 {{ $i18n.locale === 'ja' ? '更新作業を行っています。しばらくお待ち下さい。' : 'BRAVE FRONTIER HEROES is being updated.' }}
    ul.timelines
      li
        a.twitter-timeline(:href="$i18n.locale === 'ja' ? 'https://twitter.com/bfheroes_pr' : 'https://twitter.com/bfh_global'" data-width="360" data-height="480")
          | {{ $i18n.locale === 'ja' ? '運営からのツイート' : 'Tweets by dev' }}
        script(async src="https://platform.twitter.com/widgets.js" charset="utf-8")
</template>
<script>
import Nl2br from 'vue-nl2br'
const PageTitle = () => import('@/components/molecules/PageTitle')
import Head from '~/assets/scripts/Head'

export default {
  layout: 'blank',
  components: { PageTitle, Nl2br },
  computed: {
    banner() {
      return require(`~/static/documents/maintenance_banner_${this.$i18n.locale == 'ja' ? 'ja' : 'en'}.txt`).default
    },
  },
  head() {
    const head = new Head({
      title: this.$t('common.meta.title'),
    })
    return head.get()
  },
}
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
  color: #444;
}

body {
  background: #f9f9f9;
  height: 100vh;
  margin: 0;
  padding: 1rem;
}

img {
  max-width: 100%;
}

h1 {
  font-size: 1.2rem;
}

.page500 {
  align-items: center;
  display: flex;
  flex-direction: column;
  min-height: 100%;
  justify-content: center;
  width: 100%;
}

.box {
  align-items: center;
  border-radius: 2rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: #fff;
  margin: 2rem 0;
  padding: 2rem;
}

.nightingale>img {
  height: 256px;
  image-rendering: pixelated;
  width: 256px;
}

.timelines {
  list-style-type: none;
  margin-top: 2rem;
  padding: 0;
}

@media (min-width: 768px) {
  .timelines {
    align-items: center;
    display: flex;
    justify-content: center;
  }

  .timelines>li {
    margin: 0 1rem;
  }

  .timelines>li>a {
    align-items: center;
    color: inherit;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-decoration: none;
  }
}
</style>
